import React from 'react'
import MetaBaseDashBoardThree from '../../features/MetabaseDashBoard/MetaBaseDashBoardThree'

const MetabaseReport2 = () => {
  return (
    <div><MetaBaseDashBoardThree/></div>
  )
}

export default MetabaseReport2